export enum EventStatus {
    Initialized = 0,
    NotInitialized = 1,
    Undelivered = 2,
    Rejected = 3,
    Invalid = 4,
    Deferred = 5,
    Consumed = 6,
    NotConsumed = 7,
    Omitted = 8,
    Failed = 9,
    Forwarded = 10
}